import { Link } from "@mui/material";

/** Lightweight public presentation entry point; does not load the opening database. */
export const OpeningReference = ({ name }: { name?: string | null }) => {
  if (!name?.trim()) return <>Verified book move. This position has no named opening entry in the database.</>;
  // Match scalachess Opening.nameToKey, including accented names and punctuation.
  const key = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "_")
    .replace(/[^\w-]+/g, "");
  return (
    <Link
      href={`https://lichess.org/opening/${key}`}
      target="_blank"
      rel="noopener noreferrer"
      color="inherit"
      underline="always"
      sx={{ overflowWrap: "anywhere" }}
    >
      {name}
    </Link>
  );
};
